/**
 * @module OrderConstants
 * @requires keyMirror
 */

import keyMirror from 'keymirror';

/**
 * @const OrderConstants
 */
const OrderConstants = keyMirror({
  ORDER_DATA: null,
  ORDER_TYPE: null,
  ORDER_SUCCESS: null,
  ORDER_FAILURE: null,
  HANDLE_POPUP: null,
});

export default OrderConstants;
